export default __webpack_public_path__ + "static/media/battle_process_preview.5084ba6a.png";